import { OPERATOR } from "./dynamic-report-general.interface";

export enum ETypeSearch {
  and = 'AND',
  or = 'OR',
}

export const TYPE_SEARCH_OPTIONS = {
  [ETypeSearch.and]: {
    id: ETypeSearch.and,
    value: ETypeSearch.and,
    viewValue: 'Match ALL Criterias',
  },
  [ETypeSearch.or]: {
    id: ETypeSearch.or,
    value: ETypeSearch.or,
    viewValue: 'Match ANY Criteria',
  },
};


export enum ESortType {
  asc = 'ASC',
  desc = 'DESC',
}

export const SORT_TYPE_OPTIONS = {
  [ESortType.asc]: {
    id: ESortType.asc,
    value: ESortType.asc,
    viewValue: 'Ascending',
  },
  [ESortType.desc]: {
    id: ESortType.desc,
    value: ESortType.desc,
    viewValue: 'Descending',
  },
};


export const CONDITION_OPTIONS = {
  [OPERATOR.EQUAL]: {
    id: OPERATOR.EQUAL,
    value: OPERATOR.EQUAL,
    viewValue: 'EQUAL TO',
  },
  [OPERATOR.NOT_EQUAL]: {
    id: OPERATOR.NOT_EQUAL,
    value: OPERATOR.NOT_EQUAL,
    viewValue: 'NOT EQUAL',
  },
};